import styled from "styled-components";

export const Display = styled.div`
    display:flex;
    box-sizing:border-box;
    font-family:helvetica;
`;